import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { PublicAppElement } from './public-app-element';

export class PublicAppPanel extends PublicAppElement {
    elm: HTMLElement;
    appearance: any;

    private navigationButtons: any;
    get buttons(): object {
        return this.navigationButtons;
    }

    @property({ type: Object })
    set buttons(value: object) {
        const oldValue = this.navigationButtons;
        this.navigationButtons = value;
        this.requestUpdate('buttons', oldValue);
    }

    private headerText: String = 'Header';

    getElement(): HTMLElement | undefined | null {
        return this.shadowRoot?.querySelector(".panel-container");
    }
    setHeader(header) {
        let elm = this.shadowRoot?.querySelector("#panel-header-text");
        elm && (elm.innerHTML = header);
        this.headerText = header;
    }
    setBody(content) {
        let elm = this.shadowRoot?.querySelector(".panel-body");
        elm && (elm.innerHTML = content);
    }
    setBodyFromElement(content) {
        let elm = this.shadowRoot?.querySelector(".panel-body");
        elm && elm.append(content);
    }
    setBodyFromUrl(url: string) {
        let elm = this.shadowRoot?.querySelector(".panel-body");
        let loader = elm && elm.querySelector("public-app-content-loader");
        if (!loader) {
            elm && (elm.innerHTML = "");
            loader = document.createElement("public-app-content-loader");
            loader.setAttribute("systemEnv", this.systemEnv);
            loader.setAttribute("appVersion", this.appVersion);
            elm && elm.appendChild(loader);
        }
        loader.setAttribute("url", url);
    }
    renderFor(id) {

    }
    setAppearance(details: any) {
        this.appearance = details;
    }
    moveTo(x, y) {
        let elm = this.getElement();
        let elmWd: any = this.appearance?.width?.replace("px", "") || elm?.style?.width?.replace("px", "")
        elmWd = +elmWd;
        if (x + elmWd > document.body.clientWidth + window.scrollX) {
            x = document.body.clientWidth - elmWd - 5 + + window.scrollX;
            if (x < 0) x = 0;
        }
        elm && (elm.style.left = x + "px")
        elm && (elm.style.top = y + "px")
    }
    moveToCenter() {
        let elm = this.getElement();
        let newTop = (window.innerHeight - 400) / 2 + window.scrollY;
        if (newTop < 0) {//If it goes less than 0, the dialog title will not be visible
            newTop = 0;
        }
        elm && (elm.style.top = newTop + "px")
        elm && (elm.style.left = ((window.innerWidth - elm.clientWidth) / 2 + window.scrollX) + "px")
    }
    getBackDrop() {
        return this.shadowRoot?.querySelector("#backDrop");
    }
    isVisible() {
        let elm = this.getElement();
        return elm && (elm.style?.display == "block");
    }
    show() {
        let elm = this.getElement();
        if (this.appearance) {
            this.appearance.width && elm && (elm.style.width = this.appearance.width);
        }
        elm && (elm.style.display = "block");
        if (this.appearance.modal) {
            let bkDrop: any = this.getBackDrop();
            if (bkDrop) {
                bkDrop.classList.remove("d-none");
                bkDrop.classList.add("d-block");
            }
            if (!this.appearance.customBackdropClass) {
                this.moveToCenter();
            }
        }
    }
    hide() {
        let elm = this.getElement();
        elm && (elm.style.display = "none");
        if (this.appearance.modal) {
            let bkDrop: any = this.getBackDrop();
            if (bkDrop) {
                bkDrop.classList.remove("d-block");
                bkDrop.classList.add("d-none");
            }
        }
    }
    getAutoCloseStyle() {
        let hasClose = this.appearance && this.appearance.hasOwnProperty("close");
        return (!hasClose || this.appearance?.close) ? "panel-close" : "d-none";
    }
    render() {
        return html`
        <link rel="stylesheet" href="/css/global.css?v=${this.appVersion}">
        <div id="panel-container" class="panel-container card ${this.appearance?.customClass}" style="display:none;">
            <div id="panel-header" class="panel-header d-flex justify-content-between">
                <span id="panel-header-text">${this.headerText}</span>
                <button class="${this.getAutoCloseStyle()}" @click=${this.hide}><i class="bi bi-x-lg"></i></button>
            </div>
            <div id="panel-body" class="panel-body">
                Body
            </div>
            ${this.getButtonsPanel()}
            <div id="panel-footer" class="panel-footer" style="display:none">
                footer
            </div>
        </div>
        <div class="${this.appearance?.customBackdropClass}">
            <div id='backDrop' class="modal semitransparent d-none"></div>
        </div>
    `;
    }
    buttonClick(e: any) {
        let elm = e && e.target
        let btn = elm && this.navigationButtons && this.navigationButtons.length && this.navigationButtons[elm.getAttribute("data-index")]
        btn && btn.handler();
    }
    getButtonsPanel() {
        return !(this.navigationButtons && this.navigationButtons.length) ? html`` : html`<div class='panel-button-container d-flex justify-content-end'>${this.getAllButtons()}</div>`;
    }
    getAllButtons() {
        return html`${this.navigationButtons.map(
            (btn, index) => html`<button data-index=${index} class="btn btn-primary ${btn.isDefault ? 'default' : ''}" @click=${this.buttonClick}>${btn.text}</button>`
        )}`;
    }
}
declare global {
    interface HTMLElementTagNameMap {
        'public-app-panel': PublicAppPanel;
    }
}